module.exports = __webpack_public_path__ + "bell.svg";